import { PaginatedAPIResponse } from "../models/NetworkResponse";
import { GetVendorsParams, Vendor } from "../models/Vendors/Vendor";
import { deleteAPI, getAPI, postAPI, putAPI } from "../api/Networking";
import WarehouseAPI from "../api/WarehouseAPI";
import { makeObservable, observable } from "mobx";
import { Warehouse, WarehouseRack } from "../models/Warehouse/Warehouse";

export default class WarehouseStore {
  WarehouseAPI: WarehouseAPI;
  warehouses: Warehouse[];
  warehouseRacks: WarehouseRack[];

  constructor() {
    this.WarehouseAPI = new WarehouseAPI();
    this.warehouses = [];
    this.warehouseRacks = [];
    makeObservable(this, {
      warehouses: observable,
      warehouseRacks: observable,
    });
  }

  searchWarehouse = async (city_id?: number | undefined) => {
    try {
      const result = await this.WarehouseAPI.searchWarehouse(city_id);
      this.warehouses = result;
    } catch (error: any) {
      throw error;
    }
  };

  searchWarehouseRack = async (warehouse_id: string, search_text: string) => {
    try {
      const result = await this.WarehouseAPI.searchWarehouseRack(
        warehouse_id,
        search_text,
      );
      this.warehouseRacks = result;
    } catch (error: any) {
      throw error;
    }
  };

  clearWarehouseRacks = () => {
    this.warehouseRacks = [];
  };
}
